import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http, errMsg } from "@/pages/Admin";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    http.post("/auth/google-session", { session_id: sessionId })
      .then(({ data }) => {
        sessionStorage.removeItem("tsr_token");
        navigate("/admin", { replace: true, state: { user: data } });
      })
      .catch((e) => {
        toast.error(errMsg(e));
        navigate("/admin", { replace: true });
      });
  }, [location.hash, navigate]);

  return null;
}
